import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import {
    CompanyAdminWorkgroupsQuery,
    WorkgroupsForCompanyResponse,
    fetchWorkgroupsForCompany,
} from "../../workgroups/workgroupsApi"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"

export const ALL_WORKGROUPS = 0

const useStyles = makeStyles()(() => ({
    input: {
        minWidth: "12rem",
    },
}))

const selectWorkgroupOptions = (data: WorkgroupsForCompanyResponse) =>
    data.workgroups.map((workgroup) => ({ id: workgroup.id, name: workgroup.name }))

type SelectWorkgroupDropdownProps = Readonly<{
    workgroupId: number
    setWorkgroupId: (workgroupId: number) => void
}>

export function SelectWorkgroupDropdown({ workgroupId, setWorkgroupId }: SelectWorkgroupDropdownProps) {
    const { classes } = useStyles()
    const { companyId } = useCurrentCompany()

    const workgroupsResult = useApiQuery(fetchWorkgroupsForCompany, {
        queryName: CompanyAdminWorkgroupsQuery.LIST,
        dependencies: { companyId },
        select: selectWorkgroupOptions,
    })

    const workgroups = workgroupsResult.data ?? []

    return (
        <FormControl className={classes.input} size="small">
            <LocalizedStrict id="company-organization-users-table-header-select-label-workgroup">
                <InputLabel id="workgroup-select-label">Workgroup</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict
                id="company-organization-users-table-header-select-workgroup-field"
                attrs={{ label: true }}
            >
                <Select
                    labelId="workgroup-select-label"
                    id="workgroup-select"
                    value={String(workgroupId)}
                    label="Workgroup"
                    onChange={(event) => setWorkgroupId(Number(event.target.value))}
                >
                    <MenuItem value={String(ALL_WORKGROUPS)}>
                        <LocalizedStrict id="company-organization-users-table-header-select-item-all">
                            <span>All</span>
                        </LocalizedStrict>
                    </MenuItem>
                    {workgroups.map((workgroup) => (
                        <MenuItem key={workgroup.id} value={String(workgroup.id)}>
                            {workgroup.name}
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
